var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("common-grid", {
    ref: "commonGrid",
    attrs: {
      list: _vm.GL5040101Response.dataGrid,
      "total-line-cnt": _vm.GL5040101Response.totalCnt,
      "scroll-event": true,
      tagType: "div",
      totalCss: ["total-count", "no-border"]
    },
    on: { reSearch: _vm.scrollEvent },
    scopedSlots: _vm._u([
      {
        key: "list",
        fn: function(data) {
          return [
            _c("div", { staticClass: "box-white -type4" }, [
              _c("div", { staticClass: "header" }, [
                _c(
                  "div",
                  {
                    staticClass: "title",
                    on: {
                      click: function($event) {
                        return _vm.goToDetail(data.row)
                      }
                    }
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t(data.row.corpBzwkCd + "_결재선사용거래")
                        ) +
                        " "
                    ),
                    _c("i", { staticClass: "icon icon-arrow-m-right" }),
                    data.row.aprvalDmndDstcd == "0"
                      ? _c("div", { staticClass: "state ing" }, [
                          _vm._v(_vm._s(_vm.$t("2_결재상태구분")))
                        ])
                      : _c("div", { staticClass: "state wait" }, [
                          _vm._v(_vm._s(_vm.$t("1_결재상태구분")))
                        ])
                  ]
                ),
                _c("div", { staticClass: "desc" }, [
                  _c("div", { staticClass: "item account" }, [
                    _vm._v(
                      " " +
                        _vm._s(/*건수*/ _vm.$t("PCOP-02-01-01-07")) +
                        " : " +
                        _vm._s(data.row.trsaccRqstNoitm) +
                        " "
                    )
                  ])
                ])
              ]),
              _c("div", { staticClass: "content" }, [
                _c("div", { staticClass: "account-info -type3" }, [
                  _c("div", { staticClass: "item amount" }, [
                    _c("span", { staticClass: "exchange-unit" }, [
                      _vm._v(_vm._s(data.row.trsaccCncycd))
                    ]),
                    _c("span", {
                      staticClass: "total",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$num(data.row.trsaccAmt, null, true)
                        )
                      }
                    })
                  ]),
                  _c("div", { staticClass: "item sub" }, [
                    _vm.isView(data.row.corpBzwkCd)
                      ? _c("div", { staticClass: "cont" }, [
                          _c("span", { staticClass: "tit" }, [
                            _vm._v(
                              _vm._s(
                                /*출금계좌번호*/ _vm.$t("PCOP-02-01-01-08")
                              )
                            )
                          ]),
                          _c("span", { staticClass: "dec" }, [
                            _vm._v(_vm._s(data.row.drwotAcno))
                          ])
                        ])
                      : _vm._e(),
                    _c("div", { staticClass: "cont" }, [
                      _c("span", { staticClass: "tit" }, [
                        _vm._v(_vm._s(/*등록자*/ _vm.$t("PCOP-02-01-01-09")))
                      ]),
                      _c("span", { staticClass: "dec" }, [
                        _vm._v(_vm._s(data.row.aprvalRegiCustnm))
                      ])
                    ]),
                    _c("div", { staticClass: "cont" }, [
                      _c("span", { staticClass: "tit" }, [
                        _vm._v(_vm._s(/*등록 일시*/ _vm.$t("PCOP-02-01-01-10")))
                      ]),
                      _c("span", { staticClass: "dec" }, [
                        _vm._v(
                          _vm._s(_vm.$getGlobalDateFmt(data.row.regiYmd)) +
                            " " +
                            _vm._s(_vm.$getGlobalTimeFmt(data.row.regiYms))
                        )
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }